import React, { useState } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import userActions from '../../user/duck/userActions';
import siteService from '../../sites/duck/siteService';


// const billHistoryOption = { key: 'bill-history', label: 'View Billing History' };
// const changePaymentOption = { key: 'update-payment', label: 'Change Payment Information' };
// const cancelSubscriptionOption = { key: 'cancel-subs', label: 'Cancel Subscription', className: 'red-color' };

// function menuOptions(hasBillHistoryOption) {
//     const options = [changePaymentOption, cancelSubscriptionOption];
//     if (hasBillHistoryOption) {
//         options.unshift(billHistoryOption);
//     }
//     return options;
// }

// const menuOptions = [
//     { key: 'bill-history', label: 'View Billing History' },
//     { key: 'update-payment', label: 'Change Payment Information' },
//     { key: 'cancel-subs', label: 'Cancel Subscription', className: 'red-color' }
// ];

function FarmSubscriptionsItem({
    objectId,
    siteId,
    name,
    subscription,
    status,
    isEditMode,
    originalPlan,
    parent,
    isAdmin,
    isGroguruAdmin,
    openDoneModal,
    hasStripeCustomerDetails,
    email,
    address,
    username,
    phone,
    showDialogue,
    askConfirmation,
    activeNewSubscription,
    setActiveNewSubscriptions,
    updateStripeCustomer,
    onStatusChange
}) {

    const [isActive, setIsActive] = useState(status === 'ACTIVE');
    const [isToggling, setIsToggling] = useState(false);

    // Get current plan (from changes or original subscription)
    const currentChange = activeNewSubscription.find(item => item.siteId === siteId);
    const currentPlan = currentChange?.currentPlan || subscription || 'None';

    return (
        <tr>
            <td>{siteId}</td>
            <td>{name}</td>
            {/* Show Subscribed Plan in view mode, checkboxes in edit mode */}
            {!isEditMode ? (
                <td>{subscription || 'None'}</td>
            ) : (
                <td>
                    <input
                        style={{ width: '25px', height: '25px', marginRight: '20px' }}
                        value="Gold"
                        name={`plan${siteId}`}
                        type="checkbox"
                        onChange={() => changePlan('Gold')}
                        checked={currentPlan === 'Gold'}
                    />
                    <input
                        style={{ width: '25px', height: '25px', marginRight: '20px' }}
                        value="Silver"
                        name={`plan${siteId}`}
                        type="checkbox"
                        onChange={() => changePlan('Silver')}
                        checked={currentPlan === 'Silver'}
                    />
                    <input
                        style={{ width: '25px', height: '25px' }}
                        value="None"
                        name={`plan${siteId}`}
                        type="checkbox"
                        onChange={() => changePlan('None')}
                        checked={currentPlan === 'None'}
                    />
                </td>
            )}
            <td>
                {isToggling ? (
                    <Spinner animation="border" size="sm" />
                ) : (
                    <Form.Check
                        type="switch"
                        id={`active-switch-${siteId}`}
                        label={isActive ? 'Yes' : 'No'}
                        checked={isActive}
                        onChange={handleActiveToggle}
                        disabled={isToggling}
                        style={{ cursor: 'pointer' }}
                    />
                )}
            </td>
        </tr>
    )

    function handleActiveToggle(e) {
        const newActiveState = e.target.checked;
        setIsToggling(true);

        const serviceCall = newActiveState
            ? siteService.activateSite(objectId)
            : siteService.deactivateSite(objectId);

        serviceCall
            .then(() => {
                setIsActive(newActiveState);
                setIsToggling(false);
                // Notify parent component of status change
                if (onStatusChange) {
                    onStatusChange(objectId, newActiveState ? 'ACTIVE' : 'INACTIVE');
                }
            })
            .catch((error) => {
                setIsToggling(false);
                // Show error to user
                if (showDialogue) {
                    showDialogue(
                        'Activation Error',
                        `Failed to ${newActiveState ? 'activate' : 'deactivate'} site. Please try again.`
                    );
                }
                console.error('Site activation error:', error);
            });
    }

    function changePlan(newPlan) {
        const oldPlan = originalPlan || subscription || 'None';

        // Remove any existing change for this site
        const filteredChanges = activeNewSubscription.filter(item => item.siteId !== siteId);

        // If the new plan is the same as the original, don't add to changes
        if (newPlan === oldPlan) {
            setActiveNewSubscriptions(filteredChanges);
        } else {
            // Add the new change
            setActiveNewSubscriptions([
                ...filteredChanges,
                {
                    siteId: siteId,
                    oldPlan: oldPlan,
                    currentPlan: newPlan
                }
            ]);
        }
    }
}

const mapStateToProps = state => {
    const { profile } = state.userDetails.profileDetails;
    return {
        hasStripeCustomerDetails: !!profile.stripeCustomerDetails,
        email: profile.email,
        address: profile.address,
        username: profile.name,
        phone: profile.phone,
        isAdmin: profile.role.name.includes('admin'),
        isGroguruAdmin: profile.role.name === 'groguru_admin'
    }
}

const mapDispatchToProps = {
    updateStripeCustomer: userActions.updateStripeCustomer
}

export default connect(mapStateToProps, mapDispatchToProps)(FarmSubscriptionsItem)